import { createSlice } from '@reduxjs/toolkit'
import { AnnouncementValues } from '../types'
// Define the type for the state
interface StateType {
    announcementList: AnnouncementValues[]
    currentPage: number
    totalCount: number
}

const formState: StateType = {
    announcementList: [],
    currentPage: 1,
    totalCount: 1,
}

const announcementSlice = createSlice({
    name: 'announcement',
    initialState: formState,
    reducers: {
        saveAnnouncementList: (state, action) => {
            state.announcementList = action.payload.data
            state.totalCount = action.payload.totalCount
            state.currentPage = action.payload.currentPage
        },
        deleteAnnouncementFromList: (state, action) => {
            state.announcementList = state.announcementList.filter(
                (announcement: AnnouncementValues) =>
                    announcement.id !== action.payload.id
            )
        },
    },
})

export default announcementSlice.reducer

export const { saveAnnouncementList, deleteAnnouncementFromList } =
    announcementSlice.actions
